export type DeepLinkRouteCondition = {
    path: string;
    equals?: unknown;
};

export type DeepLinkRoutePatternRule = {
    when?: DeepLinkRouteCondition;
    routePattern: string;
};

export type DeepLinkRouteMapping = {
    routePattern?: string;
    routePatternRules?: DeepLinkRoutePatternRule[];
    openPanelId?: string;
};

/**
 * @todo
 * We should see if we can collapse this mapping down to only nodes that actually map to unique pages.
 * In fact, there should only ever be a single entry for a given entity - a route to its "details" page.
 * Unless, there's an entity that does not have a details page, but only a list view. In such a case:
 *      - If the entity is a root entity, then it MUST have its own list page, so we route to that.
 *      - If the entity is a child entity, then a deep link to it must have been created from a parent entity's details
 *          view, and the path will indicate which parent. So we should route to that parent entity's details page.
 */
export const DEEP_LINK_ROUTE_MAPPINGS: Record<string, DeepLinkRouteMapping> = {
    organization: {
        routePattern: '/organizations/{organization.id}/details'
    },
    person: {
        routePattern: '/people/{person.id}/details'
    },
    production: {
        routePatternRules: [
            {
                when: {
                    path: 'production.state',
                    equals: 'pipeline'
                },
                routePattern: '/pipeline'
            },
            {
                when: {
                    path: 'production.managedProduction',
                    equals: true
                },
                routePattern: '/workspace/{production.id}/details'
            }
        ]
    },
    'production.resource': {
        routePattern: '/workspace/{production.id}/resource/{production.resource.id}/details'
    },
    'production.resource.shortlist.shortlistlineitem': {
        routePattern: '/workspace/{production.id}/resource/{production.resource.id}/details'
    },
    'production.resource.opportunity': {
        routePattern:
            '/workspace/{production.id}/resource/{production.resource.id}/details/booking/{production.resource.opportunity.id}/details'
    },
    'production.activity': {
        routePattern: '/workspace/{production.id}/details'
    },
    'production.deal': {
        routePattern: '/workspace/{production.id}/details'
    },
    opportunity: {
        routePatternRules: [
            {
                when: {
                    path: 'opportunity.state',
                    equals: 'Booking'
                },
                routePattern: '/details/{opportunity.id}'
            },
            {
                when: {
                    path: 'opportunity.state',
                    equals: 'Lead'
                },
                routePattern: '/details/{opportunity.id}'
            }
        ]
    },
    'opportunity.resource': {
        routePatternRules: [
            {
                when: {
                    path: 'opportunity.state',
                    equals: 'Booking'
                },
                routePattern: '/details/{opportunity.id}'
            }
        ]
    },
    'shortlist.shortlistlineitem': {
        routePattern: '/shortlists/{shortlist.id}/details'
    }
};
